import React from 'react'
import styled from '@emotion/styled'
import { string } from 'prop-types'
import PardotForm from 'components/PardotForm'

// Styled Components via Emotion
const ApplicationFormWrapper = styled.div`
	background: #f8fafb;
	height: 100%;
	padding-top: 2.5rem;
	width: 100%;
`
const Title = styled.h2`
	${({ theme }) => theme.header.h2};
	color: ${({ theme }) => theme.colors.navy};
	font-weight: 400;
	margin: 0;
	text-align: center;
`
const SubTitle = styled.p`
	${({ theme }) => theme.header.bodyLarge};
	color: ${({ theme }) => theme.colors.darkGrey};
	font-weight: 400;
	margin: auto;
	text-align: center;
	width: 80%;

	${({ theme }) => theme.MQ.M} {
		max-width: 550px;
		width: 100%;
	}
`
const SectionHeader = styled.div``

ApplicationForm.propTypes = {
	subTitle: string,
	title: string.isRequired,
}

/**
 * This is the Application Form section on the Connect Page
 * It pulls in the Marketo Form component
 *
 * Data is dynamic, but added defaults (based on mocks)
 */
function ApplicationForm({
	subTitle = 'Millions of decision makers rely on the business.com marketplace to discover, compare, and purchase products for their business.',
	title = 'Advertise with Us',
}) {
	return (
		<ApplicationFormWrapper id="marketo-form">
			<SectionHeader id="section-header">
				<Title>{title}</Title>
				<SubTitle>{subTitle}</SubTitle>
			</SectionHeader>
			<PardotForm src="https://connect.business.com/l/900901/2020-12-01/3m4g" height="1000" width="100%" />
		</ApplicationFormWrapper>
	)
}

export default ApplicationForm
